import moment from 'moment';

import { toLocalOffset } from 'zoomforth_zfutils/datetime_formatting.js';

// We define the switchover moment to be June 1, 2016 midnight PST
export const switchoverMoment = toLocalOffset(moment('2016-06-01T00:00:00-07:00'));


export const hasOldDataTimeframe = ({ start })=>
  start.isBefore(switchoverMoment);

export const hasNewDataTimeframe = ({ end })=>
  end.isAfter(switchoverMoment);


export const doesStraddleSwitchover = ({ start, end })=>
  start.isBefore(switchoverMoment) && end.isAfter(switchoverMoment);

export const getStraddlingTimeframes = ({ start, end })=> {

  var oldTimeframe = null;
  if (hasOldDataTimeframe({ start, end })) {
    oldTimeframe = {
      start,
      end: moment.min(end, switchoverMoment)
    };
  }

  var newTimeframe = null;
  if (hasNewDataTimeframe({ start, end })) {
    newTimeframe = {
      start: moment.max(switchoverMoment, start),
      end
    };
  }

  return {
    oldTimeframe,
    newTimeframe
  };
};